
<div class="page-container">
  <app-spinner *ngIf="this.loading"></app-spinner>  
  <div class="page-padding">    
    <mat-tab-group class="tab-style" animationDuration="0ms" (selectedTabChange)="onTabChanged($event)" #tab>
      <mat-tab class="tab-style" label="New Requests">
        <br />
        <app-new-requests (eventClick)="handleChildEmitter($event)"></app-new-requests>
      </mat-tab>
      <mat-tab  label="Submitted Requests">
        <br />
        <span >
          <app-submitted-requests [tabParentEvent]="tabParentValue"></app-submitted-requests>
        </span>   
      
      </mat-tab>
      <mat-tab  label="Commission Policy">
        <br />
        <app-commission-policy></app-commission-policy>
      </mat-tab>    
  
    </mat-tab-group>
  </div>

  </div>